import Header from "../../shared/ArtistHeader/header";
import Footer from "../../shared/footer/footer";
import AccountInformationComponent from "../../components/artist/artistAccountInformation";

const AccountView = () => {
	return (
		<div>
			<Header />
			<AccountInformationComponent />
			<Footer />
		</div>
	);
};

export default AccountView;
